import theme from './theme-subsidi-tepat.json';
import styles from './styles.scoped.css';

export const subsidiTheme = {
  // Basic font configuration
  fontFamily: 'Poppins, Open Sans, sans-serif',
  fontFamilyMonospace: 'monospace',

  // Headings configuration
  headings: {
    fontWeight: '600',
    textWrap: 'balance',
    sizes: {
      h1: { fontSize: '2.5rem', lineHeight: '1.4' },
      h2: { fontSize: '2rem', lineHeight: '1.4' },
      h3: { fontSize: '1.75rem', lineHeight: '1.4' },
      h4: { fontSize: '1.5rem', lineHeight: '1.4' },
      h5: { fontSize: '1.25rem', lineHeight: '1.4' },
      h6: { fontSize: '1rem', lineHeight: '1.4' },
    },
  },

  // Colors configuration
  colors: {
    // Mapping your primary colors,
    'primary-ptm': ['#5E811E'],
    primary: [
      theme.colors.primary[25].value,
      theme.colors.primary[50].value,
      theme.colors.primary[100].value,
      theme.colors.primary[200].value,
      theme.colors.primary[300].value,
      theme.colors.primary[400].value,
      '#5E811E',
      // theme.colors.primary[500].value,
      // theme.colors.primary[600].value,
      '#577919',
      theme.colors.primary[700].value,
      theme.colors.primary[800].value,
      theme.colors.primary[900].value,
    ],
    // Secondary colors
    secondary: [
      theme.colors.secondary[25].value,
      theme.colors.secondary[50].value,
      theme.colors.secondary[100].value,
      theme.colors.secondary[200].value,
      theme.colors.secondary[300].value,
      theme.colors.secondary[400].value,
      theme.colors.secondary[500].value,
      theme.colors.secondary[600].value,
      theme.colors.secondary[700].value,
      theme.colors.secondary[800].value,
      theme.colors.secondary[900].value,
    ],

    tertiary: [
      theme.colors.tertiary[25].value,
      theme.colors.tertiary[50].value,
      theme.colors.tertiary[100].value,
      theme.colors.tertiary[200].value,
      theme.colors.tertiary[300].value,
      theme.colors.tertiary[400].value,
      theme.colors.tertiary[500].value,
      theme.colors.tertiary[600].value,
      theme.colors.tertiary[700].value,
      theme.colors.tertiary[800].value,
      theme.colors.tertiary[900].value,
    ],
    // Error colors
    error: [
      theme.colors.error[25].value,
      theme.colors.error[50].value,
      theme.colors.error[100].value,
      theme.colors.error[200].value,
      theme.colors.error[300].value,
      theme.colors.error[400].value,
      theme.colors.error[500].value,
      theme.colors.error[600].value,
      theme.colors.error[700].value,
      theme.colors.error[800].value,
      theme.colors.error[900].value,
    ],
    // Success colors
    success: [
      theme.colors.success[25].value,
      theme.colors.success[50].value,
      theme.colors.success[100].value,
      theme.colors.success[200].value,
      theme.colors.success[300].value,
      theme.colors.success[400].value,
      theme.colors.success[500].value,
      theme.colors.success[600].value,
      theme.colors.success[700].value,
      theme.colors.success[800].value,
      theme.colors.success[900].value,
    ],
    // Warning colors
    warning: [
      theme.colors.warning[25].value,
      theme.colors.warning[50].value,
      theme.colors.warning[100].value,
      theme.colors.warning[200].value,
      theme.colors.warning[300].value,
      theme.colors.warning[400].value,
      theme.colors.warning[500].value,
      theme.colors.warning[600].value,
      theme.colors.warning[700].value,
      theme.colors.warning[800].value,
      theme.colors.warning[900].value,
    ],
    information: [
      theme.colors.information[25].value,
      theme.colors.information[50].value,
      theme.colors.information[100].value,
      theme.colors.information[200].value,
      theme.colors.information[300].value,
      theme.colors.information[400].value,
      theme.colors.information[500].value,
      theme.colors.information[600].value,
      theme.colors.information[700].value,
      theme.colors.information[800].value,
      theme.colors.information[900].value,
    ],
  },

  components: {
    Modal: {
      defaultProps: {
        radius: 12,
      },
      styles: (theme) => ({
        title: {
          fontWeight: 600,
          fontSize: theme.fontSizes.lg,
          lineHeight: 1.2,
        }
      }),
    },
    Select: {
      classNames: {
        option: styles.cusAllSelectOption
      },
      defaultProps: {
        withCheckIcon: false
      }
    },
    Textarea: {
      styles: {
        label: {
          fontSize: '1rem',
          fontWeight: 600
        }
      }
    }
  },

  // Base colors
  white: theme.colors.base.white.value,
  black: theme.colors.base.black.value,

  // Primary color configuration
  primaryColor: 'primary',
  primaryShade: { light: 6, dark: 8 },

  // Border radius configuration based on your radius tokens
  radius: {
    xs: `${theme.radius[1].value}px`,
    sm: `${theme.radius[2].value}px`,
    md: `${theme.radius[3].value}px`,
    lg: `${theme.radius[4].value}px`,
    xl: `${theme.radius[5].value}px`,
  },
  defaultRadius: 'sm',

  focusRing: 'auto',
  cursorType: 'pointer',
  fontSmoothing: true,

  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },

  breakpoints: {
    xs: '36em',
    sm: '48em',
    md: '62em',
    lg: '75em',
    xl: '88em',
  },
};

export default subsidiTheme;
